import { NgModule } from '@angular/core';
import { XpAvatarComponent } from '@xp/avatar/xp-avatar.component';
import { XpBackButtonComponent } from '@xp/back-button/xp-back-button.component';
import { XpBadgeComponent } from '@xp/badge/xp-badge.component';
import { XpButtonComponent } from '@xp/button/xp-button.component';
import { XpCardComponent } from '@xp/card/xp-card.component';
import { XpChartComponent } from '@xp/chart/xp-chart.component';
import { XpColumnHeaderComponent } from '@xp/column-header/xp-column-header.component';
import { XpColumnListComponent } from '@xp/column-list/xp-column-list.component';
import { XpDateRangeComponent } from '@xp/date-range/xp-date-range.component';
import { XpDateTimeComponent } from '@xp/date-time/xp-date-time.component';
import { XpDetailLayoutComponent } from '@xp/detail-layout/xp-detail-layout.component';
import { XpDialogComponent } from '@xp/dialog/xp-dialog.component';
import { XpDialogHeaderComponent } from '@xp/dialog-header/xp-dialog-header.component';
import { XpDocThumbComponent } from '@xp/doc-thumb/xp-doc-thumb.component';
import { XpDotComponent } from '@xp/dot/xp-dot.component';
import { XpDrawerComponent } from '@xp/drawer/xp-drawer.component';
import { XpDropZoneComponent } from '@xp/drop-zone/xp-drop-zone.component';
import { XpEmptyStateComponent } from '@xp/empty-state/xp-empty-state.component';
import { XpExpanderComponent } from '@xp/expander/xp-expander.component';
import { XpFieldComponent } from '@xp/field/xp-field.component';
import { XpFileRowComponent } from '@xp/file-row/xp-file-row.component';
import { XpGalleryCaptionDirective, XpGalleryComponent, XpGalleryItemDirective, XpGalleryThumbnailDirective } from '@xp/gallery/xp-gallery.component';
import { XpHeaderComponent } from '@xp/header/xp-header.component';
import { XpInfoRowComponent } from '@xp/info-row/xp-info-row.component';
import { XpInputComponent } from '@xp/input/xp-input.component';
import { XpLoadingComponent } from '@xp/loading/xp-loading.component';
import { XpMenuSelectComponent } from '@xp/menu-select/xp-menu-select.component';
import { XpMessageComponent } from '@xp/message/xp-message.component';
import { XpOtpInputComponent } from '@xp/otp-input/xp-otp-input.component';
import { XpPageHeaderComponent } from '@xp/page-header/xp-page-header.component';
import { XpPaginatorComponent } from '@xp/paginator/xp-paginator.component';
import { XpPasswordFieldComponent } from '@xp/password-field/xp-password-field.component';
import { XpPasswordStrengthComponent } from '@xp/password-strength/xp-password-strength.component';
import { XpPhoneFieldComponent } from '@xp/phone-field/xp-phone-field.component';
import { XpRatingStarsComponent } from '@xp/rating-stars/xp-rating-stars.component';
import { XpReviewComponent } from '@xp/review/xp-review.component';
import { XpSearchFieldComponent } from '@xp/search-field/xp-search-field.component';
import { XpSectionHeaderComponent } from '@xp/section-header/xp-section-header.component';
import { XpShellComponent } from '@xp/shell/xp-shell.component';
import { XpSidebarComponent } from '@xp/sidebar/xp-sidebar.component';
import { XpStatComponent } from '@xp/stat/xp-stat.component';
import { XpTableComponent } from '@xp/table/xp-table.component';
import { XpToastsComponent } from '@xp/toasts/xp-toasts.component';
import { XpToggleButtonsComponent } from '@xp/toggle-buttons/xp-toggle-buttons.component';

const XP_COMPONENTS = [
	XpAvatarComponent,
	XpBackButtonComponent,
	XpBadgeComponent,
	XpButtonComponent,
	XpCardComponent,
	XpChartComponent,
	XpColumnHeaderComponent,
	XpColumnListComponent,
	XpDateRangeComponent,
	XpDateTimeComponent,
	XpDetailLayoutComponent,
	XpDialogComponent,
	XpDialogHeaderComponent,
	XpDocThumbComponent,
	XpDotComponent,
	XpDrawerComponent,
	XpDropZoneComponent,
	XpEmptyStateComponent,
	XpExpanderComponent,
	XpFieldComponent,
	XpFileRowComponent,
	XpGalleryCaptionDirective,
	XpGalleryComponent,
	XpGalleryItemDirective,
	XpGalleryThumbnailDirective,
	XpHeaderComponent,
	XpInfoRowComponent,
	XpInputComponent,
	XpLoadingComponent,
	XpMenuSelectComponent,
	XpMessageComponent,
	XpOtpInputComponent,
	XpPageHeaderComponent,
	XpPaginatorComponent,
	XpPasswordFieldComponent,
	XpPasswordStrengthComponent,
	XpPhoneFieldComponent,
	XpRatingStarsComponent,
	XpReviewComponent,
	XpSearchFieldComponent,
	XpSectionHeaderComponent,
	XpShellComponent,
	XpSidebarComponent,
	XpStatComponent,
	XpTableComponent,
	XpToastsComponent,
	XpToggleButtonsComponent
];

@NgModule({
	imports: XP_COMPONENTS,
	exports: XP_COMPONENTS
})
export class XpKitModule { }
